export const GET_AUDIT_LOGS_START = 'GET_AUDIT_LOGS_START';
export const GET_AUDIT_LOGS_SUCCESS = 'GET_AUDIT_LOGS_SUCCESS';
export const GET_AUDIT_LOGS_FAILED = 'GET_AUDIT_LOGS_FAILED';
export const GET_AUDIT_LOGS_EXPORT_START = 'GET_AUDIT_LOGS_EXPORT_START';
export const GET_AUDIT_LOGS_EXPORT_SUCCESS = 'GET_AUDIT_LOGS_EXPORT_SUCCESS';
export const GET_AUDIT_LOGS_EXPORT_FAILED = 'GET_AUDIT_LOGS_EXPORT_FAILED';


export const getAuditLogsStart = () => ({
  type: GET_AUDIT_LOGS_START
});

export const getAuditLogsSuccess = (data) => ({
  type: GET_AUDIT_LOGS_SUCCESS,
  data
});

export const getAuditLogsFailed = (error) => ({
  type: GET_AUDIT_LOGS_FAILED,
  error
});

export const getAuditLogsExportStart = () => ({
  type: GET_AUDIT_LOGS_EXPORT_START
});

export const getAuditLogsExportSuccess = (data) => ({
  type: GET_AUDIT_LOGS_EXPORT_SUCCESS,
  data
});

export const getAuditLogsExportFailed = (error) => ({
  type: GET_AUDIT_LOGS_EXPORT_FAILED,
  error
});
